import { useMemo } from 'react';
import type LayoutStyles from '../@types/api/styles';

let _cachedStyles: LayoutStyles | null | undefined = undefined;

const getStyles = (): LayoutStyles | null => {
    if (_cachedStyles !== undefined) return _cachedStyles;

    try {
        const raw = localStorage.getItem('styles');
        _cachedStyles = raw ? (JSON.parse(raw) as LayoutStyles) : null;
    }
    catch {
        _cachedStyles = null;
    }
    return _cachedStyles;
};

const useLayoutStyles = () => {
    return useMemo(() => getStyles(), []);
};

export default useLayoutStyles;
